import { defineStore } from "pinia";
import { ref } from "vue";

export const useClockStore = defineStore(
  "clock",
  () => {
    const subject = ref("");
    const startTime = ref("");
    const finishTime = ref("");
    const ExtraDetails = ref([]);

    return { subject, startTime, finishTime, ExtraDetails };
  },
  {
    persist: {
      key: "projector-clock-storage", // Custom key in localStorage
      storage: localStorage,
      // CRITICAL: This allows the projector window to listen
      // for changes made in the controller window.
      sync: true,
    },
  },
);
